{
  "nl": {
    "task": {
      "actions": {
        "create": "Taak",
        "update": "Taak bewerken"
      },
      "attributes": {
        "assignments_count": "Toewijzingen",
        "category": "Categorie",
        "created_at": "Aangemaakt",
        "description": "Omschrijving",
        "title": "Titel",
        "units": "Eenheden"
      },
      "categories": {
        "confirmation": "Bevestiging",
        "upload": "Upload"
      },
      "labels": {
        "no_tasks": "Nog geen taken voor dit project.",
        "required": "Dit veld is verplicht",
        "units_required": "Selecteer minstens één eenheid"
      },
      "toasts": {
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
